import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

import { computed } from 'vue'
import { hsvToRGB, RGBColor } from '../utils/hsvToRGB'

//


export default /*#__PURE__*/_defineComponent({
  __name: 'ColorizedText',
  props: {
    texts: {},
    colorIndexMapper: { default: null },
    sep: { default: '' }
  },
  setup(__props: any) {

const props = __props;



const textStyles = computed(() => {
  const ret = [] as any[]
  const coloredTextCount = props.colorIndexMapper?.length ?? props.texts.length

  for (let i = 0; i < props.texts.length; i++) {
    let colorIndex: number
    if (props.colorIndexMapper != null) {
      colorIndex = -1
      for (let j = 0; j < props.colorIndexMapper.length; j++) {
        if (props.colorIndexMapper[j] === i) {
          colorIndex = j
          break
        }
      }
    } else {
      colorIndex = i
    }
    let rgb: RGBColor
    if (colorIndex === -1) {
      ret.push({ 'font-style': 'italic' })
    } else {
      rgb = hsvToRGB(colorIndex / coloredTextCount, 1, 0.7)
      ret.push({ 'font-weight': 'bold', color: `rgb(${rgb.r}, ${rgb.g}, ${rgb.b})` })
    }
  }
  return ret
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.texts, (text, i) => {
      return (_openBlock(), _createElementBlock("span", { key: i }, [
        _createElementVNode("span", {
          style: _normalizeStyle(textStyles.value[i])
        }, _toDisplayString(text), 5),
        _createTextVNode(_toDisplayString(_ctx.sep), 1)
      ]))
    }), 128))
  ]))
}
}

})